module.exports = __webpack_public_path__ + "img/华为云.91467bf0.png";